import React from "react";
import OrPodcastCategoryPromote from "../../../components/OrPodcastCategoryPromote";

export default function PodcastCategoryPromote(props) {
  return <OrPodcastCategoryPromote {...props} />;
}
